export const serUtSomIdentitetsbeteckning = (vad: string): boolean => {
    return /(\d|-)+$/.test(vad);
};

export const orgnummerRegex = `^\\d{6}(-|\\+)\\d{4}$` as string;

// export const epostRegex = `^$|(([\\w\\-\\.])+@([\\w\\-]+\\.)+([\\w\\-]{1,10})$)` as string;
export const epostRegex = `^$|^((?=.{0,50}$)[^\\s()<>@,;:\\\\".\\[\\]]+(\\.[^\\s()<>@,;:\\\\".\\[\\]]+)*@([^\\s()<>@,;:\\\\"\\[\\]]+\\.)+([^\\s()<>@,;:\\\\".\\[\\]]{1,})$)` as string;

